import { isBaseUrlProd } from '@shared';

export type SupportedCountryCode = '+1' | '+91' | '+63';

type Country = {
  code: SupportedCountryCode;
  label: string;
  flag: string;
  placeholder: string;
};

const ALL_COUNTRIES: Country[] = [
  { code: '+1', label: 'United States', flag: '🇺🇸', placeholder: '(555) 555-5555' },
  { code: '+91', label: 'India', flag: '🇮🇳', placeholder: '98765 43210' },
  { code: '+63', label: 'Philippines', flag: '🇵🇭', placeholder: '912 345 6789' },
];

// Prod restricts to +1 only; dev/local exposes the full list (used for testing
// with non-US numbers). Single-element list also signals to the UI to render
// the country select as disabled.
export const SUPPORTED_COUNTRIES: Country[] = isBaseUrlProd()
  ? ALL_COUNTRIES.filter((c) => c.code === '+1')
  : ALL_COUNTRIES;

export const stripDigits = (v: string) => v.replace(/\D/g, '');

export function formatByCountry(digits: string, country: SupportedCountryCode): string {
  const d = digits.slice(0, 10);
  if (country === '+1') {
    if (d.length <= 3) return d;
    if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  }
  if (country === '+91') {
    return d.length <= 5 ? d : `${d.slice(0, 5)} ${d.slice(5)}`;
  }
  // '+63'
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)} ${d.slice(3)}`;
  return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6)}`;
}

export function validateForCountry(digits: string, country: SupportedCountryCode): string | null {
  if (digits.length !== 10) return 'Enter a 10-digit phone number';
  if (country === '+1' && /^[01]/.test(digits)) return 'Invalid US area code';
  if (country === '+91' && !/^[6-9]/.test(digits)) {
    return 'Indian mobile numbers start with 6, 7, 8, or 9';
  }
  if (country === '+63' && !/^9/.test(digits)) {
    return 'Philippine mobile numbers start with 9';
  }
  return null;
}

const REMOVE_FROM_EXISTING = /please remove it from your existing account first\.?/i;

export const clerkMessage = (err: { longMessage?: string; message?: string } | null | undefined) => {
  if (!err) return null;
  const base = err.longMessage || err.message;
  if (!base) return null;
  return base.replace(REMOVE_FROM_EXISTING, 'please contact us.');
};
